export default __webpack_public_path__ + "static/media/VI.7dc45b0f.svg";